var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"tree-container"},[_c('el-tree',{ref:"tree",staticClass:"tree-line",attrs:{"highlight-current":"","indent":0,"data":_vm.arr,"node-key":"id","props":_vm.defaultProps},on:{"node-click":_vm.handleNodeClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }